export default function Hero() {
  const stats = [
    { label: '影视资源', value: '50,000+' },
    { label: '每日更新', value: '50+' },
    { label: 'CDN节点', value: '120+' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden opacity-20">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20atmosphere%20with%20soft%20warm%20golden%20light%20rays%20piercing%20through%20darkness%2C%20abstract%20movie%20theater%20vibe%2C%20subtle%20film%20grain%20texture%2C%20elegant%20geometric%20light%20patterns%2C%20luxurious%20dark%20amber%20mood%2C%20no%20text%20no%20people&width=1600&height=900&seq=hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/40 via-background-50/20 to-background-50"></div>

      <div className="relative w-full mx-auto px-4 md:px-6 max-w-[1400px] pt-24 pb-16">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/15 border border-accent-500/25 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-xs font-medium text-accent-500 whitespace-nowrap">即点即播 · 不缓冲秒开</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight mb-6">
              8848影院
              <br />
              <span className="text-primary-500">高清流畅</span>
              <span className="text-foreground-950"> · </span>
              <span className="text-foreground-950">免费在线观影</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-4 max-w-xl lg:max-w-none">
              海量影视资源汇聚，覆盖电影、电视剧、综艺、动漫、纪录片等全品类内容。
            </p>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8 max-w-xl lg:max-w-none">
              自研流媒体引擎搭配全球CDN加速，真正做到即点即播、流畅不卡顿。
              无需注册、无需会员、无需安装，打开浏览器就能畅享极致观影体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">{s.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#media"
                className="whitespace-nowrap flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer"
              >
                <i className="ri-play-circle-fill text-xl w-5 h-5 flex items-center justify-center"></i>
                开始观影
              </a>
              <a
                href="#features"
                className="whitespace-nowrap flex items-center gap-2 px-8 py-3.5 rounded-full border border-background-300 text-foreground-700 text-base font-medium hover:border-primary-500 hover:text-primary-500 transition-all duration-200 cursor-pointer"
              >
                <i className="ri-information-line text-lg w-4 h-4 flex items-center justify-center"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Luxurious%20home%20cinema%20setup%20with%20large%20screen%20displaying%20epic%20movie%20scene%2C%20warm%20ambient%20golden%20lighting%2C%20dark%20elegant%20interior%2C%20cinematic%20atmosphere%2C%20immersive%20viewing%20experience%2C%20no%20text%20overlay&width=800&height=600&seq=hero-visual&orientation=landscape"
                alt="8848影院超清流畅观影体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-background-50/30 via-transparent to-transparent rounded-2xl"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/80 backdrop-blur-sm">
                  <i className="ri-4k-line text-accent-500 text-sm w-4 h-4 flex items-center justify-center"></i>
                  <span className="text-xs text-foreground-800 font-medium whitespace-nowrap">4K超清</span>
                </div>
                <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/80 backdrop-blur-sm">
                  <i className="ri-flashlight-line text-primary-500 text-sm w-4 h-4 flex items-center justify-center"></i>
                  <span className="text-xs text-foreground-800 font-medium whitespace-nowrap">秒开不缓冲</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}